<template>
    <v-container fluid class="pa-3" v-if="sessionActive">

        <material-header title="Exchange reporting" info="Understand completes, revenue and efficiency"
                         icon="mdi-chart-bar">
        </material-header>

        <v-alert v-if="!hasPermission(minPermission)"
                 class="body-2"
                 type="error"
        >
            Your user account doesn't have sufficient permissions to use this feature
        </v-alert>

        <v-card v-if="hasPermission(minPermission)">

            <v-tabs color="white" slider-color="primary" v-if="hasPermission('run queries')" v-model="activeTab">

                <v-tab class="ml-3" key="cint">
                    CINT
                </v-tab>

                <v-tab key="dynata">
                    DYNATA
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
                <v-tab-item key="cint">

                </v-tab-item>

                <v-tab-item key="dynata">

                </v-tab-item>
            </v-tabs-items>

            <v-card-text>

                <v-row justify="end">

                    <v-col cols="2" class="pt-0">

                        <v-select :items="reportFilters"
                                  v-model="reportFilterModel"
                                  item-value="value"
                                  item-text="name"
                                  solo
                        ></v-select>

                    </v-col>

                </v-row>

            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>

    import Json from 'vue-json-pretty';
    import Store from '../store';
    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
    import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
    import MaterialHeader from '../../../components/UI/MaterialHeader';

    const vuexModule = 'ExchangeReporting';

    export default {

        mixins: [activeSessionChecker],

        components: {
            Json,
            MaterialHeader
        },

        data() {
            return {
                minPermission: 'view dashboard',
                reportFilters: [
                    {name: 'Today', value: 'today'},
                    {name: 'Monthly', value: 'month'}
                ],
                reportFilterModel: 'today',
                activeTab: null,
            }
        },
        computed: {

            ...mapState(vuexModule, []),

            ...mapGetters(vuexModule, []),
        },

        methods: {
            ...mapActions(vuexModule, []),

            ...mapMutations(vuexModule, []),
        },

        created() {
            if (!this.$store.state[vuexModule]) {
                this.$store.registerModule(vuexModule, Store);
            }
        },
    }

</script>
